module.exports = __webpack_public_path__ + "img/05.d043a69c.jpg";